export const LOCK_TABLE_QUERY_KEY = "table-locks";
